/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".imageInputWrapper[_ngcontent-%COMP%]{width:360px;border:1px solid #ccc;border-radius:6px;padding:10px 16px;height:46px;margin-bottom:2px}input.inputWithImage[_ngcontent-%COMP%]{width:275px;border:none;margin-right:5px;font-size:18px}"];
export { styles as styles };
